import React from 'react'
import {connect} from 'react-redux'

function responsive(browser, sizeArr, mode){
	let response = "";
	let conditionMet = false;
	for(let i=0; i<sizeArr.length; i++){
		const screenSize = Object.keys(sizeArr[i])[0];
		const value = sizeArr[i][screenSize];
		if(
			(screenSize === "lt-md" && browser.lessThan.medium) ||
			(screenSize === "gt-sm" && browser.greaterThan.small) ||
			(screenSize === "md" && browser.mediaType === "medium")
		){
			response += mode + value
			conditionMet = true;
		} else if(screenSize === "default" && !conditionMet){
			response += mode + value
		}
	}
	return response
}

export function layout(browser, sizeArr){
	return responsive(browser, sizeArr, "layout-")
}

export function flex(browser, sizeArr){
	return responsive(browser, sizeArr, "flex-")
}

function generateDesktopXMobileY(props,x,y){
	const myflex = flex(props.browser, [
		{"lt-md" : y},
		{"default" : x}
	])
	const mylayout = layout(props.browser, [
		{"lt-md" : "column"},
		{"default" : "row"}
	])
	return <div className={`${mylayout} ${myflex} ${props.className ? props.className : ""}`}>{props.children}</div>
}

export const DesktopRowMobileColumn = connect( (state) => state ) ( function(props){
	return generateDesktopXMobileY(props, "100","100")
})

export const DesktopRow33MobileColumn100 = connect( (state) => state ) ( function(props){
	return generateDesktopXMobileY(props, "33","100")
})

export const DesktopRow66MobileColumn100 = connect( (state) => state ) ( function(props){
	return generateDesktopXMobileY(props, "66","100")
})
	


// WEBPACK FOOTER //
// ./src/components/responsive.js